document.addEventListener("DOMContentLoaded", function() {
  var triggerElement = document.querySelector(".trigger");
  var stickyButton = document.querySelector(".sticky-button");
  var targetElement = document.querySelector("#title");
  if (!triggerElement || !stickyButton || !targetElement) return;
  var triggerOffset = triggerElement.offsetTop;
  var hasClickedButton = false;

  stickyButton.style.display = "none"; 

  function handleScroll() {
    var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollPosition >= triggerOffset && !hasClickedButton) {
      stickyButton.style.display = "block";
    } else {
      stickyButton.style.display = "none";
    }
    
    if (scrollPosition < triggerOffset) {
      stickyButton.style.display = "none";
    }
  }

  window.addEventListener("scroll", handleScroll);

  function handleClick() {
    targetElement.scrollIntoView({ behavior: "smooth" });
    stickyButton.style.display = "none";
    hasClickedButton = true;
  }

  stickyButton.addEventListener("click", handleClick);
});
